<ion-app>
  <div [ngClass]="{'alert-message': true, 'show': alert}">
    <app-alert-info></app-alert-info>
  </div>
  <div id="update-banner" class="update-banner" i18n>
    Une nouvelle version est disponible. <a href="#" id="reload-link">Mettre à jour</a>
  </div>
  <ion-router-outlet [ngClass]="{'test': alert}">
  </ion-router-outlet>
</ion-app>
